{
	"description": "Entitlement Template for Jira Software (Cloud) Free",
	"features": []
}
